var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92575 20L8.75875 19.9804C3.51484 19.3218 -0.313023 14.6857 0.0201925 9.39673C0.353408 4.10774 4.73268 -0.00843053 10.0175 1.29667e-05C15.3024 0.00845646 19.6686 4.13859 19.985 9.42863C20.3014 14.7187 16.4588 19.3425 11.2128 19.9843L11.0781 20L10.9824 19.001L11.0918 18.9892C15.8135 18.4129 19.273 14.2521 18.9893 9.49081C18.7056 4.72953 14.7766 1.01143 10.02 1.00298C5.26346 0.994531 1.32137 4.69864 1.02084 9.45889C0.720312 14.2191 4.1651 18.3922 8.88476 18.9853L9.0371 19.003L8.92575 20ZM9.5029 4.9595H10.5029V6.96914H9.5029V4.9595ZM10.5029 7.96574H9.5029V14.9948H10.5029V7.96574Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.0785edf56a71873ed3962c1389597ec070c66fea3e17c43121475ccc93fe1862.svg";
export { ForwardRef as ReactComponent };